// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:32:44+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            afade2c873219795095fb5a6c713e81e
//    Signature:      eyJpdiI6IjFhdjBWVDR1ZCtlMFlRdFlWSUJGT3c9PSIsInZhbHVlIjoiQ1V3OEc2MTQzV1BUdzM4RkdZZXdvcnlackd2TW9JM1c1Q0tldVZkYW5sRTBTVUROclB4QXppc00raEpXK0p5MVZBN3BSQ2R2ZFRhR0l6RURvaGRLUDU3Q0FWU2FtcHgzaTE3dVBHcGJUSW9ZcjVKUmpmYXM1TjdzRGlaUGdrNHNxcUhhTURNbVNXd0ZQelo4ZzZkMExJUUhhdkFKV3c0U2x6OGY1cFVxQ0ZJRFoxWUxJKzkyMzNCS1wvUzJtQTVFaE9jT1wvSjNzVGRQRFlqNytkS3dhWFBaNXlSQk9KXC9IR3NxNWN0RURjc0pkQ1NcL1hRV213dXhueWRXcWZ6RFh5Wis1VStZQmZYa2ErRDh2T0MybjFUdkhmejlOdm9HV2NQWU5HVFUwa0crZVZsOXdLMGhZbkYzUWZ0Q0loTllWZExaZGNVMkxhSU5ialF5ckMyVGk0SlltOXlqYmlOQjlhRjArZ2dZN2NnT0Y4c3dacE1sN2JnM1RjcHJOWWlXcE8rMFF0RCtsdnJkQVY4bEZiZDRvZjhOaHc9PSIsIm1hYyI6IjBlNDFkNjhjZDc1OThhNTYwOWM1NTQ4M2UyMTAxZmI0YzBjNmYzNTU0NTM5ZjdlMTY0NGZhZGM2ZjdjN2ZlOTkifQ==
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
